import React from 'react';
import { AuthorizedView } from '@webbyx/mui';
import { useAuthIdentity } from '@webbyx/next-js';

import { hasAccess } from './helpers';
import { AuthViewProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const AuthView: React.FC<AuthViewProps> = (props) => {
  const { children, permissions } = props;
  const { authUser } = useAuthIdentity();

  // ======================= HOOKS
  return (
    <AuthorizedView
      authUser={authUser}
      authorization={(user) => {
        return hasAccess(user, permissions);
      }}
    >
      {children}
    </AuthorizedView>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './hooks';
export * from './helpers';
export * from './props';
export default AuthView;
